import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import { ChecklistTemplate,GetChecklistTemplates, DeleteChecklistTemplate,  NetworkMember,  CompassStateModel, GetServiceLevels, ServiceLevel } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { SavedProvider } from '../settings.component';
import { EditChecklistTemplatesDialog } from '../../components/edit-checklist-templates-dialog/edit-checklist-templates-dialog';


const moment = moment_;

@Component({
  selector: 'checklist-templates',
  templateUrl: './checklist-templates.html',
  styleUrls: ['./checklist-templates.scss']
})
export class ChecklistTemplates implements OnInit {

  @Input() provider : SavedProvider;
  @Select(state => state.compassState) checklistTemplateState$: Observable<CompassStateModel>;
  checklistTemplatesSubscription : Subscription;
  checklistTemplates : ChecklistTemplate[] = [];
  serviceLevels : ServiceLevel[];

  constructor(
    private store : Store,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {


  }

  ngOnInit(): void {
    this.  checklistTemplatesSubscription  = this.checklistTemplateState$.subscribe((compassState: CompassStateModel) => {
      console.log(compassState);
      if (compassState && compassState.checklistTemplates ) {
         this.checklistTemplates = [].concat(compassState.checklistTemplates);
      }
      if (compassState && compassState.serviceLevels ) {
        this.serviceLevels = [].concat(compassState.serviceLevels);
     }
      console.log(this.checklistTemplates, this.checklistTemplates.map(g => g.name), this.serviceLevels, this.serviceLevels.map(g => g.name));   
    });

    console.log(this.provider);
    this.store.dispatch(new GetChecklistTemplates(this.provider.id));
    this.store.dispatch(new GetServiceLevels(this.provider.id));
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  getItemsAsString(checklistTemplate : ChecklistTemplate) : string {
    return checklistTemplate.items.map(s => s.item).join(', ');
  }

  editChecklistTemplate(checklistTemplate : ChecklistTemplate) {
    this.dialog.open(EditChecklistTemplatesDialog, {
      width: '600px',
      data: {
        checklistTemplate: checklistTemplate,
        provider: this.provider,
        serviceLevels : this.serviceLevels
      }
    });
  }


  deleteChecklistTemplate(checklistTemplate : ChecklistTemplate) {
    this.store.dispatch(new DeleteChecklistTemplate(checklistTemplate.id)).subscribe( );
  }


}